import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "uploadContainer"
};
const _hoisted_3 = {
  class: "uploadContent"
};
const _hoisted_4 = {
  class: "image-upload-placeholder"
};
const _hoisted_5 = {
  class: "image-upload-requirements-placeholder"
};
const _hoisted_6 = {
  class: "cropperContainer"
};
const _hoisted_7 = {
  class: "cropperImageWrapper"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "cropperControls"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  key: 1,
  class: "loading-container"
};
const _hoisted_12 = {
  class: "modal-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_icon_button = _resolveComponent("icon-button");
  const _component_loader = _resolveComponent("loader");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_w_dialog = _resolveComponent("w-dialog");
  return _openBlock(), _createBlock(_component_w_dialog, {
    visible: _ctx.isVisible,
    title: _ctx.$t('imageUploader.title'),
    "close-on-click-modal": false,
    onOnDialogClose: _ctx.closeModal,
    class: "image-uploader-dialog"
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_standard_button, {
      outlined: true,
      label: _ctx.$t('messageBox.cancel'),
      onClick: _ctx.cancelCropping
    }, null, 8, ["label", "onClick"]), _createVNode(_component_standard_button, {
      label: _ctx.$t('messageBox.ok'),
      disabled: _ctx.isLoading,
      onClick: _ctx.validateCropping
    }, null, 8, ["label", "disabled", "onClick"])])]),
    default: _withCtx(() => [!_ctx.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_upload, {
      drag: "",
      accept: "image/*",
      "show-file-list": false,
      "auto-upload": false,
      onChange: _ctx.onFileUploaded
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_icon, {
        icon: "upload-outline",
        size: "large",
        color: "light1"
      }), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('imageUploader.instruction')), 1), _createElementVNode("div", _hoisted_5, " (" + _toDisplayString(_ctx.$t('imageUploader.requirements', {
        imgMaxSize: _ctx.imageMaxSize
      })) + ") ", 1)])]),
      _: 1
    }, 8, ["onChange"])], 512), [[_vShow, !_ctx.isCropping]]), _withDirectives(_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
      src: _ctx.fileUploadUrl,
      class: "cropperSource",
      ref: "cropperSource"
    }, null, 8, _hoisted_8)]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_icon_button, {
      color: "white",
      icon: "aspect-ratio",
      onClick: _ctx.resetCropper
    }, null, 8, ["onClick"]), _createVNode(_component_icon_button, {
      color: "white",
      icon: "rotate-left",
      onClick: _ctx.rotateLeft
    }, null, 8, ["onClick"]), _createVNode(_component_icon_button, {
      color: "white",
      icon: "rotate-right",
      onClick: _ctx.rotateRight
    }, null, 8, ["onClick"]), _createVNode(_component_icon_button, {
      color: "white",
      icon: "magnify-plus-outline",
      onClick: _ctx.zoomPlus
    }, null, 8, ["onClick"]), _createVNode(_component_icon_button, {
      color: "white",
      icon: "magnify-minus-outline",
      onClick: _ctx.zoomMinus
    }, null, 8, ["onClick"]), _createVNode(_component_icon_button, {
      color: "white",
      icon: "delete-outline",
      onClick: _ctx.removeImage
    }, null, 8, ["onClick"])]), _createElementVNode("img", {
      src: _ctx.cropperPreviewUrl,
      class: "cropperPreview",
      ref: "cropperPreview"
    }, null, 8, _hoisted_10)], 512), [[_vShow, _ctx.isCropping]])])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_loader), _createElementVNode("p", null, [_createTextVNode(_toDisplayString(_ctx.$t('imageUploader.uploadingMsgTop')) + " ", 1), _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$t('imageUploader.uploadingMsgBottom')), 1)])]))]),
    _: 1
  }, 8, ["visible", "title", "onOnDialogClose"]);
}